<template>
	<div id="SocialMediaPostRecovery">
		<div class="container-fluid d-flex flex-column align-items-center">
				<div class="col-12 col-md-10 text-center row justify-content-center">
					<template v-if="countImportedMedia > 0">
							<div
								v-for="(media, index) in totalMedia"
								:key="index"
								class="m-3 media-grid cursor-pointer"
								:class="{ active: media.save_media }"
								@click="toggleMedia(media)"
							>
									<baseImage 
										:source="media.images[0].url" 
										:externalImage="true" 
										:customClass="'img-fluid'" />
								<span class="icon-group" v-if="media.images.length > 1">
									<img src="../../assets/img/icons/Grupo.svg" alt class="mt-2 mr-2" />
								</span>
							</div>
					</template>
					<template v-else-if="!apiInProgress">
						<h5>Nenhum conteúdo encontrado.</h5>
					</template>
					<div class="container-button">
						<button
							class="btn btn-primario btn-extra-large"
							id="mediaManagerButton"
							@click="$emit('importSocialMediaContent')"
						>
							Adicionar
						</button>
					</div>
				</div>
			</div>
		</div>
</template>

<script>
	import baseImage from "@/components/atoms/BaseImage";

	import apiMixins from "@/mixins/apiMixins";
	import { mapGetters, mapState } from "vuex";
	export default {
		name: "SocialMediaPostRecovery",
		components: {
			baseImage,
		},
		data() {
			return {
				apiInProgress: false,
				errorApi: false,
				nextUrl: "",
				postsToImport: [],
			};
		},
		mixins: [apiMixins],
		computed: {
			...mapState("dashboardModule", {
				totalMedia: (state) =>
					state.importedMedia.media.filter(
						(image) => typeof image == "object"
					),
			}),
			...mapGetters("dashboardModule", ["countImportedMedia", "getNextUrl"]),
			noMediaMessage() {
				if (this.apiInProgress) {
					return `Buscando seus conteúdos`;
				} else if (this.errorApi) {
					return `Erro ao recuperar seus posts`;
				} else if (!this.nextUrl) {
					return `Não há mais conteúdos`;
				}
			},
		},
		methods: {
			async getSocialMediaPosts() {
				this.apiInProgress = true;
				this.errorApi = false;
				const url = `/site/${this.$session.get(
					"siteId"
				)}/integrations/recent`;
				const responseApi = await this.requestApiData(url, "get");
				if (responseApi.status === "1") {
					this.$store.dispatch("dashboardModule/populateImportedMedia", [
						responseApi.medias,
						responseApi.next,
					]);
				}
				this.apiInProgress = false;
			},
			async loadMorePosts() {
				if (this.getNextUrl) {
					this.apiInProgress = true;
					this.errorApi = false;
					const url = this.getNextUrl;
					const responseApi = await this.requestApiData(url, "get");
					if (responseApi.status === "1") {
						this.$store.dispatch(
							"dashboardModule/populateImportedMedia",
							[responseApi.medias, responseApi.next]
						);
					}
					this.apiInProgress = false;
				}
			},
			toggleMedia(media) {
				this.$store.dispatch("dashboardModule/toggleMedia", [media]);
			},
			textButton() {
				return this.apiInProgress ? `Carregando` : `Buscar`;
			},
		},
		created() {
			if (this.countImportedMedia == 0) {
				this.getSocialMediaPosts();
			}
		},
	};
</script>

<style scoped>
	#SocialMediaPostRecovery {
	position: relative;
	z-index: 10;
}
.try-again {
	cursor: pointer;
}
.load-more {
	color: var(--main-color);
	cursor: pointer;
}
.media-grid {
	border: 3px solid transparent;
	border-radius: 5px;
	transform: scale(0.97);
	transition: all 300ms;
	position: relative;
}
.media-grid:hover {
	transform: scale(1);
}
.media-grid.active {
	border: 3px solid var(--main-color);
	transform: scale(1);
}
.base-image {
	height: 300px;
	width: 300px;
	object-fit: cover;
}
.media-picture {
	grid-area: 1 / 1 / 3 / 3;
	border-radius: 5px;
	overflow: hidden;
	z-index: -1;
}
.icon-group {
	position: absolute;
	right: 0;
}
.check-item-group {
	font-size: 20px;
	position: absolute;
	bottom: 0;
	left: 5px;
}
.check-item-group i {
	color: var(--main-color);
}
.container-button {
	position: fixed;
	bottom: 0;
	left: 0;
	right: 0;
	padding: 20px 10px;
	display: flex;
	justify-content: center;
	align-content: center;
}
</style>


// WEBPACK FOOTER //
// src/components/molecules/SocialMediaPostRecovery.vue